<template lang="pug">
  div.citizen.appeals
    e-toolbar(
    :items="items"
      @deleteItems="deleteItems"
        :hideRemoveButton="true"
      :hideImportBtn="true"
      routeMapName="citizen.appealsMap"
       :showActionsPanel="false"
      :showTotal="false"
    ref="toolbar"
    )
      div(slot="filter").horizontal
        div.filter-block
          label Категория
          e-select(
            name="cat_id"
            :model="filterModel"
            :options="appealCats"
            hide-placeholder
            @change="applyFilter()"
          )
        div.filter-block
          label Статус
          e-select(
            name="answer_status_id"
            :model="filterModel"
            :options="appealStatuses"
             hide-placeholder
             @change="applyFilter()"
          )
          e-button-add(
            @click="$refs.toolbar.add()"
          )
    e-table(
    :items="items"
      @deleteItem="deleteItem"
        @editItem="editItem"
        :showCheckbox="false"
    )

    router-view
</template>

<script>
  import {mongoApi} from '../../api/api-endpoints.js'
  import tableMixin from '../../components/table/table-mixin.js'
  import {Appeals} from '../../config/mongo'
  import {SHOW_HIDDEN_FIELDS, APPEAL_CATS_WITH_ALL, APPEAL_STATUSES_WITH_ALL} from '../../config/config'

  export default {
    mixins: [tableMixin],
    data () {
      return {
        filterModel: {
          cat_id: '',
          answer_status_id: ''
        }
      }
    },
    computed: {
      filterFormName () {
        return 'filter'
      },
      appealCats () {
        return APPEAL_CATS_WITH_ALL
      },
      appealStatuses () {
        return APPEAL_STATUSES_WITH_ALL
      }
    },
    methods: {
      getEndpoint (route, fromRoute) {
        return mongoApi.getCollectionItems(Appeals, route)
      },
      getDeleteUrl (id) {
        return mongoApi.deleteCollectionItem(Appeals, id)
      }
    }
  }
</script>
